import { Edit3, Loader2 } from 'lucide-react'
import { Button } from '@/components/ui/Button'
import type { Proposta } from '@/types'
import { findRenegotiationDraft, findSentProposals } from './proposalRenegotiation'

function scrollToProposalForm() {
  window.setTimeout(() => {
    document.getElementById('proposal-form-editor')?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    })
  }, 0)
}

export function RenegociacaoProposalBanner({
  proposals,
  onEditDraft,
  onEnsureDraft,
  showForm,
  editingDraftId,
  preparingDraft = false,
  variant = 'renegociacao',
}: {
  proposals: Proposta[]
  onEditDraft: (draft: Proposta) => void
  onEnsureDraft?: () => void | Promise<void>
  showForm: boolean
  editingDraftId: string | null
  preparingDraft?: boolean
  variant?: 'renegociacao' | 'ajustar_proposta'
}) {
  const sent = findSentProposals(proposals)
  const draft = findRenegotiationDraft(proposals)
  const isEditingDraft = Boolean(draft && showForm && editingDraftId === draft.id)

  const handleEditDraftClick = () => {
    if (draft) {
      onEditDraft(draft)
      scrollToProposalForm()
      return
    }
    void onEnsureDraft?.()
  }

  if (sent.length === 0 && !draft && !preparingDraft) return null

  return (
    <div className="rounded-lg border border-orange-500/25 bg-orange-500/10 p-4 space-y-2">
      <p className="text-sm font-medium text-text-primary">
        {variant === 'ajustar_proposta' ? 'Ajuste solicitado pelo financeiro' : 'Em renegociação'}
      </p>
      <p className="text-xs text-text-muted leading-relaxed">
        {variant === 'ajustar_proposta'
          ? sent.length > 0
            ? 'A proposta enviada permanece no histórico. Edite o rascunho com os ajustes pedidos e depois volte para Gerar Contrato.'
            : 'Monte a versão ajustada da proposta com base no pedido do financeiro.'
          : sent.length > 0
            ? 'A proposta enviada fica no histórico e não pode ser alterada. No rascunho você inclui ou remove planos e reenvia quando estiver pronta.'
            : 'Monte uma nova versão da proposta e envie ao cliente.'}
      </p>
      {preparingDraft ? (
        <div className="flex items-center gap-2 text-xs text-text-muted">
          <Loader2 size={14} className="animate-spin text-accent" />
          Preparando rascunho a partir da proposta enviada…
        </div>
      ) : sent.length > 0 && !isEditingDraft ? (
        <Button
          variant="primary"
          size="sm"
          icon={<Edit3 size={13} />}
          onClick={handleEditDraftClick}
        >
          {draft ? 'Editar plano ofertado' : 'Carregar proposta para edição'}
        </Button>
      ) : null}
    </div>
  )
}
